import { render, staticRenderFns } from "./DeleList.vue?vue&type=template&id=59e56f34&scoped=true&"
import script from "./DeleList.vue?vue&type=script&lang=js&"
export * from "./DeleList.vue?vue&type=script&lang=js&"
import style0 from "./DeleList.vue?vue&type=style&index=0&id=59e56f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e56f34",
  null
  
)

export default component.exports